export interface ITrelloClient {
    getMember<O extends GetMemberOptions>(options: O): Promise<TrelloMember>;
}

export type GetMemberOptions = {
    readonly id?: string;
    readonly aaId?: string;
    readonly username?: string;
    readonly fullName?: string;
    readonly email?: string;
    readonly fields?: readonly Exclude<keyof TrelloMember, "id">[];
    readonly organizations?: "all" | "members" | "none" | "public";
    readonly organizationFields?: readonly Exclude<
        keyof TrelloOrganization,
        "id"
    >[];
    readonly credits?: "all" | "freeTrial";
};

export type TrelloMember = {
    readonly id: string;
    readonly aaId: string;
    readonly username: string;
    readonly fullName: string;
    readonly email: string;
    readonly idPremOrgsAdmin?: readonly string[];
    readonly organizations?: readonly TrelloOrganization[];
    readonly credits?: unknown[];
};

export type TrelloOrganization = {
    readonly id: string;
    readonly displayName?: string;
    readonly memberships?: TrelloOrganizationMembership[];
    readonly name?: string;
    readonly url?: string;
    readonly products?: number[];
};

export type TrelloOrganizationMembership = {
    readonly id: string;
    readonly idMember: string;
    readonly memberType: "normal" | "admin";
    readonly unconfirmed: boolean;
    readonly deactivated: boolean;
};
